<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 222.13 218.79" style="enable-background:new 0 0 222.13 218.79;" xml:space="preserve">
    <g>
        <circle :style="defineStroke" class="st0" cx="134.94" cy="85.94" r="79.46"/>
        <circle :style="defineStroke" class="st1" cx="134.94" cy="85.94" r="58.72"/>
        <path :style="defineStroke" class="st1" d="M90.56,89.21c0-26.41,21.41-47.82,47.82-47.82"/>
        <path :style="defineStroke" class="st0" d="M89.56,151.28L34.34,206.5c-6.39,6.39-16.75,6.39-23.14,0l0,0c-6.39-6.39-6.39-16.75,0-23.14l55.22-55.22"/>
        <line :style="defineStroke" class="st1" x1="55.49" y1="139.08" x2="78.63" y2="162.22"/>
        <line :style="defineStroke" class="st1" x1="47.99" y1="150.65" x2="71.13" y2="173.79"/>
    </g>
    </svg>
</template>
<script>
export default {
        data:() => ({colors: ''}),
    props:{
        status: {
            require: false,
            type: String
        }
    },
    created(){
        // console.log("STATUS: ", this.status)
        this.colors = JSON.parse(localStorage.getItem('colors'))
    },
    computed:{
        defineStroke(){
            if(this.status == 'disabled') return {'stroke': '#BABABA'}
            if(this.status == 'open') return {'stroke': this.colors.secondary}
        },
    }
}

</script>
<style type="text/css">
    .st0{fill:none;stroke-width:8;stroke-miterlimit:10;}
    .st1{fill:none;stroke-width:6;stroke-miterlimit:10;}
</style>
